import type {FC} from 'react';
import {Box, Icon, Stack, Typography} from '@wellstone-solutions/web';

interface StatusChipProps {
  icon: string;
  label: string;
  background: string;
  foreground: string;
  testId?: string;
  showTitle?: boolean;
}

export const StatusChip: FC<StatusChipProps> = ({
  icon,
  label,
  background,
  foreground,
  testId,
  showTitle,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    spacing={1}
    data-testid={testId}
    title={showTitle ? label : undefined}
    sx={{
      backgroundColor: background,
      borderRadius: 999,
      height: 32,
      maxWidth: '100%',
      minWidth: 0,
      paddingX: '14px',
      width: 'fit-content',
    }}>
    <Box sx={{display: 'inline-flex', flexShrink: 0}}>
      <Icon name={icon} size={16} color={foreground} />
    </Box>
    <Typography
      sx={{
        color: foreground,
        fontSize: 13,
        fontWeight: 500,
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}>
      {label}
    </Typography>
  </Stack>
);
